import { TrackStepDirective } from '@analytics/events';
import type { ToolTrackValues } from '@analytics/models';
import { Component, input, output } from '@angular/core';
import type { AsyncState } from '@essent/common';
import {
  SolarPanelsWizardForm,
  SolarPanelsWizardRendering,
} from '@feh/solar-panels-models';
import { ReactiveFormsAbstractionsModule } from '@innogy/feh/rfa';
import { ScFieldValuePipe } from '@innogy/feh/shared';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-solar-panels-wizard-ui',
  standalone: true,
  templateUrl: './solar-panels-wizard-ui.component.html',
  styleUrls: [
    './solar-panels-wizard-ui.component.ed.scss',
    './solar-panels-wizard-ui.component.essent.scss',
  ],
  imports: [
    ReactiveFormsAbstractionsModule,
    TrackStepDirective,
    ScFieldValuePipe,
    AutomationIdDirective,
  ],
})
export class SolarPanelsWizardUiComponent {
  public readonly formSubmit = output<void>();
  public readonly openConsumptionDialog = output<void>();

  public readonly rendering = input.required<SolarPanelsWizardRendering>();
  public readonly form = input.required<SolarPanelsWizardForm>();
  public readonly submitState = input.required<AsyncState<undefined>>();
  public readonly trackStep = input.required<ToolTrackValues>();
}
